import ModalElement from "../../../Common/ModalElement";
import { isValidObject } from "../../../utils";

const PurchaseDetails = ({ hideModal, data }) => {
    return <ModalElement show={isValidObject(data)} size="lg" title={"Purchase Details"} onHide={hideModal}>
        <div className="">
            <div className="card-body bg-white">
                <h5 className="card-title text-muted mb-3 text-start">Inventory Items</h5>

                <div className="table-responsive">
                    <table className="table table-sm table-bordered mb-0" style={{ backgroundColor: "#f9f9f9" }}>
                        <thead className="table-light">
                            <tr>
                                <th scope="col" className="text-start">Inventory Type</th>
                                <th scope="col" className="text-start">Quantity</th>
                            </tr>
                        </thead>
                        <tbody id="inventory-body">
                            {Object.entries(data?.type_counts).map((item, index) => <tr key={index}>
                                <td className="text-start">{item[0]}</td>
                                <td className="text-start">{item[1]}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>

                <div className="mt-3 p-2 bg-light border rounded d-flex">
                    <span className="fw-semibold me-2">Total Items</span>
                    <span className="fw-semibold">{data?.totalcount ?? 1}</span>
                </div>
            </div>
        </div>
    </ModalElement>
}

export default PurchaseDetails;